import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'
import { ArrayConverter } from '../../core/converters/array.converter'
import { AgrupamentoConverter } from '../converters/agrupamento.converter'
import { EmpresaQueVendeComCartoes } from '../empresa-que-vende-com-cartoes.model'
import { Agrupamento } from './agrupamento.model'
import { Extrato } from './extrato.interface'
import { Recebimento } from './recebimento.model'

@JsonApiModelConfig({
    type: 'extratos-de-recebimentos'
})
export class ExtratoDeRecebimentos extends JsonApiModel implements Extrato<Recebimento> {
    @Attribute() inicio: Date
    @Attribute() fim: Date
    @Attribute() idDaEmpresa: number
    @Attribute({
        converter: new ArrayConverter(new AgrupamentoConverter(Recebimento))
    })
    agrupamentos: Agrupamento<Recebimento>[]

    @BelongsTo() empresaQueVendeComCartoes: EmpresaQueVendeComCartoes
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/extrato/extrato-de-recebimentos.model.ts